import { useNavigate, useParams } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import EditTheMembersForm from "../../../components/apps/themembers/EditTheMembersForm";

export default function EditTheMembers() {
    const navigate = useNavigate();
    const { themembersId } = useParams();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/themembers`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar TheMembers"
                description="Editar TheMembers"
            />
            <PageBreadcrumb
                pageTitle="Editar TheMembers"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditTheMembersForm
                    theMembersId={themembersId}
                    onSuccess={() => {
                        // Redirecionar para a página de listagem de TheMembers
                        navigate(`/apps/themembers`);
                    }}
                    onError={(error: any) => {
                        console.error("Erro ao atualizar TheMembers:", error);
                    }}
                />
            </div>
        </>
    );
}